export default class ZIndex {
  static Basemap = 0;
  static SFMap = 1;
  static TocLayer = 2;
  static Drawing = 3;
  static Route = 4;
  static RouteSpotlight = 5;
  static Marker = 6;
}
